var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
export const Alert = (_a) => {
    var { showIcon, message, level = 'danger', className, children } = _a, props = __rest(_a, ["showIcon", "message", "level", "className", "children"]);
    if ((!message || (Array.isArray(message) && !message.length)) &&
        !children) {
        return null;
    }
    return (_jsxs("div", Object.assign({ className: classNames('alert', `alert-${level}`, {
            'd-flex': showIcon,
        }, className), role: "alert" }, props, { children: [showIcon && (_jsx("div", { className: "me-3 d-flex align-items-center", children: _jsx("i", { className: "bi bi-exclamation-triangle-fill" }) })), Array.isArray(message) && message.length > 1 ? (_jsxs(_Fragment, { children: [_jsx("div", { children: "Error:" }), _jsx("ul", { className: "mb-0", children: message.map((message) => (_jsx("li", { children: message }, message))) })] })) : (message), children] })));
};
